import { useCallback, useEffect, useState } from "react";
import { CustomButton } from "../../../components/CustomButton";
import RModal from "../../../components/Rsuite/Modal";
import { daysLabels } from '../../../constants/daysLabels';
import { FaCircle, FaEdit } from 'react-icons/fa';
import * as S from "./styles";
import CreateEditBairroHorario from "./CreateEdit";
import api from "../../../services/api";
import { toastError } from "../../../toasts";

const BairroHorarios = ({ modal, onClose, bairro }) => {
  const [schedules, setSchedules] = useState([]);
  const [schedule, setSchedule] = useState(null);
  const [openSchedule, setOpenSchedule] = useState(false);

  const getSchedules = useCallback(async () => {
    try {
      const { data } = await api.get(`horarios-bairro/listar-horarios/${bairro.Id}`);
      setSchedules(data);
    } catch (error) {
      console.log(error);
      toastError('Não foi carregar horários');
    }
  }, []);

  const handleOpenModal = useCallback(() => {
    setSchedule(null);
    setOpenSchedule(true);
  },[]);

  const handleEditSchedule = useCallback((schedule) => {
    setSchedule(schedule);
    setOpenSchedule(true);
  },[]);

  useEffect(() => {
    getSchedules();
  },[]);

    return (
      <>
        <RModal
          open={modal}
          onClose={onClose}
          title={'Horarios de disponibilidade do Bairro'}
          bodyStyle={{ width: 550 }}
          footer={
              <CustomButton onClick={onClose} appearance="ghost">
                Fechar
              </CustomButton>
          }
        >
          <CustomButton onClick={handleOpenModal}>
            Adicionar Horário
          </CustomButton>
          <S.ContainerSchedules>
          {schedules.map((_schedule) => (
              <S.Schedule key={_schedule.Id}>
                <S.ScheduleField>
                  <FaCircle color={_schedule.Ativo ? "#5aec3f" : "#ed3232"} />
                  {' ' + daysLabels[_schedule?.Dia]}
                </S.ScheduleField>
                <S.ScheduleField>{_schedule.Inicio}</S.ScheduleField>
                <S.ScheduleField>{_schedule.Fim}</S.ScheduleField>
                <S.ScheduleField>
                  <S.IconWrapper onClick={() => handleEditSchedule(_schedule)}>
                    <FaEdit size={12} />
                  </S.IconWrapper>
                </S.ScheduleField>
              </S.Schedule>
            ))}
          </S.ContainerSchedules>
      </RModal>
      {openSchedule && <CreateEditBairroHorario
        open={openSchedule}
        onClose={() => setOpenSchedule(false)}
        neighborhood={bairro}
        schedule={schedule}
        setSchedules={setSchedules}
      />}
    </>);
}
export default BairroHorarios;
